"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Italic = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Italic = function Italic() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3.2H17.872C17.1883 3.19589 16.5776 3.62662 16.352 4.272L11.04 19.744C10.9579 19.9872 10.9974 20.255 11.1463 20.4641C11.2952 20.6732 11.5353 20.7981 11.792 20.8H12.8C13.2418 20.8 13.6 21.1582 13.6 21.6V23.2C13.6 23.6418 13.2418 24 12.8 24H4.8C4.35817 24 4 23.6418 4 23.2V21.6C4 21.1582 4.35817 20.8 4.8 20.8H6.128C6.81166 20.8041 7.4224 20.3734 7.648 19.728L12.96 4.256C13.0431 4.01014 13.0017 3.73927 12.8491 3.5294C12.6964 3.31953 12.4515 3.19673 12.192 3.2H11.2C10.7582 3.2 10.4 2.84183 10.4 2.4V0.8C10.4 0.358172 10.7582 0 11.2 0H19.2C19.6418 0 20 0.358172 20 0.8V2.4C20 2.84183 19.6418 3.2 19.2 3.2Z"
  }));
};

exports.Italic = Italic;